module.exports = __webpack_public_path__ + "img/budget.22dea65f.svg";